/* Central map of app paths, keyed by name. Values are plain route paths (no leading "#") —
   use with react-router's <Link to={...}> and <Route path={...}> directly, or prefix with "#"
   for raw <a href> tags under HashRouter. */
export const ROUTES = {
  home: '/',
  faq: '/FAQ',
  skills: {
    root: '/skills',
    byCategory: '/skills/:category',
  },
  skillPath: {
    core: '/skillpath/1',
    discipline: '/skillpath/2',
    projectManager: '/skillpath/3',
    subjectMatterExpert: '/skillpath/4',
    leaderManager: '/skillpath/5',
    byId: '/skillpath/:id',
    byParentAndId: '/skillpath/:parentid/:id',
  },
  admin: {
    root: '/admin',
    editFaqs: '/admin/editfaqs',
    editQuiz: '/admin/editquiz',
    editCompetencyPeriod: '/admin/editcompetencyperiod',
    editSkillPath: {
      byId: '/admin/editskillpath/:id',
      byParentAndId: '/admin/editskillpath/:parentid/:id',
    },
  },
  supervisor: {
    employeeList: '/supervisor/employeelist',
  },
  competencies: {
    root: '/competencies',
    byUpn: '/competencies/:upn',
  },
  bookmarks: {
    root: '/bookmarks',
    byUpn: '/bookmarks/:upn',
  },
  reports: '/reports',
  uiTestPage: '/testPage',
  uiCore: '/core',
} as const;
